import { isNull } from 'lodash';
import APIEndpoints from '../utils/apiEndpoints';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class PostService extends AbstractService {
	static setup(baseURL, options) {
		instance = new PostService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoints = {
			posts     : APIEndpoints.posts,
			jobEvents : APIEndpoints.jobEvents,
		};
	}

	static getAllAbstract(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAllAbstract(...params);
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static getAllByJobId(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAllByJobId(...params);
	}

	static getTypes(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getTypes(...params);
	}

	_getAllAbstract({
		typeId,
		displayCount,
		pagingToken,
		officerId,
		endpoint = this.endpoints.posts,
	}) {
		return this.get({
			endpoint,
			queryParams : {
				typeId,
				displayCount,
				pagingToken,
				officerId,
			},
		});
	}

	_getAll(parameters) {
		return this._getAllAbstract(parameters);
	}

	_getAllByJobId({
		jobId,
		...rest
	}) {
		return this._getAllAbstract({
			...rest,
			endpoint : `${this.endpoints.jobEvents}/${jobId}/${this.endpoints.posts}`,
		});
	}

	_getTypes() {
		return this.get({ endpoint : `${this.endpoints.posts}/types` });
	}
}
